import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  Chip,
  Stack,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { IMensagem } from "@deltasge/marauders-map";
import parse from "html-react-parser";

const getYouTubeId = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

interface PostProps {
  post: IMensagem;
}

export const Post: React.FC<PostProps> = ({ post }) => {
  const options = {
    replace: (domNode: any) => {
      if (domNode.type === "text" && domNode.data) {
        const youtubeRegex =
          /(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11})/;
        const parts = domNode.data.split(youtubeRegex);

        if (parts.length > 1) {
          return (
            <>
              {parts.map((part: string, index: number) => {
                const videoId = getYouTubeId(part);
                if (videoId) {
                  return (
                    <iframe
                      key={index}
                      width="560"
                      height="315"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ marginTop: 8, marginBottom: 8, borderRadius: 8 }}
                    />
                  );
                }
                return part;
              })}
            </>
          );
        }
      }
    },
  };

  return (
    <Card sx={{ mb: 4, width: "100%" }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
            D
          </Avatar>
        }
        title={post.titulo}
        subheader={`${post.usuario?.nome},  ${new Date(
          post.updatedAt || ""
        ).toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        })}`}
      />

      <CardContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          {parse(post.texto || "", options)}
        </Typography>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", mt: 1 }}>
          {post.mensagemLinks?.map((link, index) => (
            <Chip
              key={index}
              label={link.url}
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              clickable
              color="primary"
              variant="outlined"
              size="small"
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
